<template>
  <div>
    <UContainer>
      <StoryblokComponent v-if="story" :blok="story.content" />
    </UContainer>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute();

const url = route.params.slug as string[];
const story = await useStoryblok(`fotogalerie/${url.join("/")}`, {});
</script>

<style></style>
